import { FC } from 'react';

import { EnquiryType } from '@shared/api/enquiry/enquiry.interface';
import { EnquiryPanel } from '@shared/containers/EnquiryForm/EnquiryPanel';

import { useTitleHook } from '../hooks/useTitleHook';

const BugoEnquiryPage: FC = () => {
  useTitleHook('문의하기');

  return <EnquiryPanel type={EnquiryType.Bugo} />;
};

export default BugoEnquiryPage;
